module.exports = __webpack_public_path__ + "img/40.8a3159ad.png";